enum FinancingType {
  EstimatedFinancing = 'estimatedFinancing',
  Expired = 'expired',
  Preapproval = 'preapproval',
  UserFinancing = 'userFinancing'
}

export default FinancingType;
